import { useQuery } from 'react-query';
import request from '../helpers/request';
import { queryKeys } from './queryKeys';

export const checkCanAddPermit = async (value) => {
  return await request.get(
    '/HousingStock/transport/check_can_add_permit',
    value,
    'При проверки возможности добавить пропуск произошла ошибка'
  );
};

const useCheckCanAddPermitQuery = (params, options = {}) =>
  useQuery(
    queryKeys.checkCanAddPermit(params),
    () => checkCanAddPermit(params),
    options
  );

export default useCheckCanAddPermitQuery;
